export default __webpack_public_path__ + "static/media/4.b57d1a93.jpg";